/* eslint-disable @typescript-eslint/ban-types */
import { FormChangeInfo } from 'rc-field-form/es/FormContext';

export default function handleFormChange(
  name: string,
  info: FormChangeInfo,
  setFormChange: (value: React.SetStateAction<{}>) => void,
) {
  if (name && info?.forms[name]) {
    setFormChange((state) => ({
      ...state,
      [name]: info.forms[name]?.getFieldsValue(),
    }));
  }
}
